import { Box, Grid, Typography } from "@mui/material";
import { Button, Toolbar, useNotify, useRecordContext } from "react-admin";
import { useAppDataContext } from "../../framework/app/app.data.context";
import { useState } from "react";

import { useMutation } from "react-query";
import { Dashboard } from "./Dashboard";
import { getConfig } from "../../framework/config/app.config";
  
const csApiUrl = getConfig('VITE_BASE_URL');

const CustomToolbar = (props) => {
  const notify = useNotify();
  const { appContext } = useAppDataContext();
  const { httpClient } = appContext || {};
  const [isSubmitting, setIsSubmitting] = useState(false);
  const tenantId: string = sessionStorage.getItem("current-tenant");
  const url = `${csApiUrl}/synchronize/synchronize`;

  // Define the custom API call using mutation
  const mutation = useMutation(
    () => {
      return httpClient(`${url}`, {
        method: "GET",
        headers: new Headers({
          Accept: "application/json",
        }),
      });
    },
    {
      onSuccess: () => {
        notify("API called successfully!", { type: "success" });
      },
      onError: () => {
        notify("API call failed", { type: "error" });
      },
    }
  );

  const handleClick = () => {
    setIsSubmitting(true);
    mutation.mutate();
    setIsSubmitting(false);
  };

  return (
    <Toolbar {...props}>
      <Button
        label="Synchronize Data"
        onClick={handleClick}
        disabled={isSubmitting}
      />
    </Toolbar>
  );
};

export const Synchronize = () => {
  let PRODUCT: string = getConfig("VITE_APP_PRODUCT");
  PRODUCT = PRODUCT.charAt(0).toUpperCase() + PRODUCT.slice(1);

  return (
    <Box sx={{ width: "100%" }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box>
            <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
              {`${PRODUCT} AI uses information from your ${PRODUCT} Systems to provide advanced analytics, intelligence and early access to new features.  You can ask the AI Assistant for sales trends and also view Analytics without ever synchronizing information into ${PRODUCT} AI.  
              For some of the features like viewing additional information about your locations, your team, your support cases etc, you can click the synchronize link below and  ${PRODUCT} AI will automatically load your information into this environment for deeper analysis.`}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <CustomToolbar />
        </Grid>
      </Grid>
    </Box>
  );
};
